import { SimplePageContentWrapper, SimplePageLayout, SimplePageHeader } from '@flexinet/ui-components';
import { RecordsTable } from '../../customers/tables/RecordsTable';
import { ReportPageNavigation } from '../navigation/ReportPageNavigation';

export const CustomersReportPage = () => {
  return (
    <SimplePageLayout
      pageHeader={<SimplePageHeader title="Customers Report" />}
      pageNavigation={<ReportPageNavigation reportName="Customers Report" />}
    >
      <SimplePageContentWrapper>
        <RecordsTable />
      </SimplePageContentWrapper>
    </SimplePageLayout>
  );
};